import { createReducer } from '@reduxjs/toolkit';

export default createReducer({
  _id: 'Inbox Guest', // just for save resized customFields <CustomField /> component
}, () => { });
